var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-h5 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.resource.dishResource.name)+" ")]),_c('div',{staticClass:"d-flex mt-1"},_vm._l((_vm.resource.resourceTags),function(tag){return _c('v-chip',{key:tag.id,staticClass:"mr-1",attrs:{"label":"","small":"","color":tag.color}},[_vm._v(" "+_vm._s(tag.name)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }